/* eslint-disable prettier/prettier */
import { Nav } from '../Nav';

export const Header = () => {
  return (
    <header>
      <Nav />
    </header>
  );
};
